module.exports = __webpack_public_path__ + "static/media/insulation_rvalues.fa93d89a.csv";